import { Tab } from '@mui/material';
import { withStyles } from '@mui/styles';

const ExpenseTab = withStyles(() => ({
    root: {
        background: 'white',
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        flexShrink: 1,
        minWidth: 0,
        minHeight: 0,

        '&$selected': {
            flexShrink: 0,
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

export default ExpenseTab;
